import styled from 'styled-components';

export const StyledPatientAutosuggestReadOnlyInput = styled.div`
   width: 100%;
   display: flex;
   flex-direction: column;
   gap: 4px;
`;
StyledPatientAutosuggestReadOnlyInput.displayName = 'StyledPatientAutosuggestReadOnlyInput';
